import { useNavigate, useSearchParams } from "react-router-dom";
import { DR_SETUP_GROUPS } from "../constants/_constant";
import "../css/SetupTable.css";
import { useEffect, useState } from "react";
import InputField from "../../common_component/component/InputField";
import SetupForm from "./SetupForm";
import { ADD_ICON } from "../../cufront-assets/icons/Icons";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import CuScreenLoader from "../../common_component/component/CuScreenLoader";
import EmptyState from "../../common_component/component/EmptyState";
import PaginationComponent from "../../common_component/component/PaginationComponent";
import TvView from "./TvView";
import { BlockSlot } from "../../new_appointment/availablility/components/BlockSlot";
import { AvailableForm } from "../../new_appointment/availablility/components/AvailableForm";
import CalenderSetup from "./CalenderSetup";
// import Certificate from "../../components/admin/setup/view/Certificate";
import { useCurrentRole } from "../../_helper/constant/Permission";
import CustomFields from "../../custom-fields/CustomFields";
import Roles from "../../roles_and_permissions/views/Roles";
import CuSpinner from "../../common_component/component/CuSpinner";
import { RiEdit2Fill } from "react-icons/ri";
import { IoEyeSharp } from "react-icons/io5";
import { FaTrash } from "react-icons/fa";
import {
  useSecureDeleteItem,
  useSecureUpdateItem,
} from "../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { toast } from "react-toastify";
import HeaderSetup from "./HeaderSetup";
import moment from "moment";
import CuButton from "../../all-patient/components/CuButton";
import PrescriptionSetup from "./PrescriptionSetup";
import Modal from "../../common_component/component/Modal";
import { CiMail } from "react-icons/ci";
import { LiaSmsSolid } from "react-icons/lia";
import { FaWhatsapp } from "react-icons/fa";
import UserTable from "../../roles_and_permissions/views/UserTable";
import CuModal from "../../common_component/component/CuModal";
import Confirmation from "../../common_component/component/Confirmation";
import Disclaimer from "../../new_appointment/availablility/views/Disclaimer";
import NotificationSetup from "./NotificationSetup";
import Certificate from "../../certificate/views/Certificate";

const SetupTable = () => {
  const [tableData, setTableData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [clinic] = useAtom(clinicAtom);
  const { role_id } = useCurrentRole();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageLimit, setPerPageLimit] = useState(15);
  const [deleteId, setDeleteId] = useState(null);
  const [searchParams] = useSearchParams();
  const groupId = searchParams.get("group_id");
  const optionId = searchParams.get("option_id");
  const mode = searchParams.get("mode");
  const [selectedOptionData, setSelectedOptionData] = useState(
    DR_SETUP_GROUPS[groupId]?.options[optionId]
  );
  const [openViewMessage, setOpenViewMessage] = useState(false);
  const [logModalData, setLogModalData] = useState(null);
  const navigate = useNavigate();

  //("currentPage", currentPage);

  const searchQuery =
    searchInput?.length > 0
      ? `&${selectedOptionData?.searchKey}=${searchInput}`
      : "";

  const handleSearch = (e) => {
    const inputValue =
      selectedOptionData?.value !== "Service Master" &&
      selectedOptionData?.value !== "Customer Master"
        ? e.target.value.toUpperCase()
        : e.target.value; // Convert input value to uppercase
    setSearchInput(inputValue); // Update the searchInput state immediately
    // debouncedHandleSearch(inputValue); // Pass the uppercase value to debounced search function
  };

  const { data, isLoading } = useItemsFilter(
    selectedOptionData?.offset,
    `${selectedOptionData?.query}&clinic_id=${clinic?.id}&page=${
      currentPage || 1
    }&records_number=${perPageLimit}${searchQuery}${
      selectedOptionData.isDrFilter ? `&doctor_id=${role_id}` : ""
    }`,
    clinic?.id && selectedOptionData?.offset?.length > 0 ? true : false,
    "invoice"
  );

  const totalPages = Math.ceil(data?.total_count / perPageLimit);

  const getMedicineTable = (data) => {
    const modifiedMedicineData = data?.map((med) => {
      return {
        id: med?.id || "",
        medicine_name: med?.medicine_name || "",
        generic_name: med?.generic_name?.name || "",
        dosage: med?.dosage?.name || "",
        unit: med?.unit?.name || "",
        when: med?.when?.name || "",
        frequency: med?.frequency?.name || "",
        // duration: med?.duration || "",
        notes: med?.notes?.name || "",
        medicine_type: med?.medicine_type?.name || "",
        // category: med?.category?.name || "",
      };
    });
    return modifiedMedicineData;
  };

  const getLogsData = (data) => {
    const modifiedLogsData = data?.map((item) => {
      return {
        id: item?.id,
        send_to: `${item?.send_to}`,
        message: item?.message,
        date_created: `${moment(item?.date_created).format(
          "DD MMM YY"
        )} :${moment(item?.date_created).format("hh:mm A")}`,
        is_email: item?.is_email,
        is_sms: item?.is_sms,
        is_whatsapp: item?.is_whatsapp,
      };
    });
    return modifiedLogsData;
  };

  const getMedicineStock = (data) => {
    const modifiedData = data?.map((ele) => {
      return {
        id: ele?.id,
        medicine_name: ele?.medicine_name,
        batch_no: ele?.batch_number,
        // medicine_id: ele?.medicine_id,
        inward_qty: ele?.inward_qty,
        uom: ele?.uom,
        expiry_date: moment(ele?.expiry_date).format("DD MMM YYYY"),
        price: ele?.price,
        received_date: moment(ele?.received_date).format("DD MMM YYYY"),
        // consumed_qty: ele?.consumed_qty,
        avl_batch_qty: ele?.avl_batch_qty,
        avl_total_qty: ele?.avl_total_qty,
      };
    });
    return modifiedData;
    // const prev_avl_total_qty_data = {};
    // const modifiedData = data?.map((ele) => {
    //   const avl_batch_qty = Number(ele?.inward_qty) - Number(ele?.consumed_qty);
    //   const avl_keys = Object.keys(prev_avl_total_qty_data);

    //   if (avl_keys?.length === 0 || !prev_avl_total_qty_data[ele.medicine_id]) {
    //     prev_avl_total_qty_data[ele?.medicine_id] = avl_batch_qty;
    //   } else {
    //     prev_avl_total_qty_data[ele?.medicine_id] =
    //       Number(prev_avl_total_qty_data[ele.medicine_id]) + avl_batch_qty;
    //   }
    //   const avl_total_qty = prev_avl_total_qty_data[ele?.medicine_id];

    //   return {
    //     id: ele?.id,
    //     medicine_name: ele?.medicine_name,
    //     medicine_id: ele?.medicine_id,
    //     inward_qty: ele?.inward_qty,
    //     uom: ele?.uom,
    //     batch_no: ele?.batch_no,
    //     received_date: ele?.received_date,
    //     expiry_date: ele?.expiry_date,
    //     price: ele?.price,
    //     consumed_qty: ele?.consumed_qty,
    //     avl_batch_qty,
    //     avl_total_qty,
    //   };
    // });
    // return modifiedData;
  };

  const getBatchData = (data) => {
    const modifiedBatch = data?.map((batch) => {
      return {
        id: batch?.id,
        batch_no: batch?.batch_number,
        medicine: batch?.medicine_name,
        batch_creation_date: moment(batch?.date_created).format("DD MMM YYYY"),
        manufacture_date: moment(batch?.date_of_manufactured).format(
          "DD MMM YYYY"
        ),
        expiry_date: moment(batch?.expiry_date).format("DD MMM YYYY"),
      };
    });
    return modifiedBatch;
  };

  const getPaymentModeData = (data) => {
    const modifiedPaymentMode = data?.map((pmode) => {
      return {
        id: pmode?.id,
        mode_of_payment: pmode?.type,
      };
    });
    return modifiedPaymentMode;
  };

  const getLabTestData = (data) => {
    const modifiedLabTestData = data?.map((item) => {
      return {
        id: item?.id,
        name: item.name,
        display_nane: item.display_name,
        related_names: item.related_names.join(","),
        ufm: item.ufm.name,
        test_category: item.test_category.name,
        lab_test_threshold: `${item?.lab_test_threshold?.min_threshold} - ${item?.lab_test_threshold?.max_threshold}`,
      };
    });
    return modifiedLabTestData;
  };

  const getTransactionData = (data) => {
    const modifiedTransactionData = data?.map((item) => {
      return {
        id: 4,
        date_consumed: item?.date_created_date,
        time: item?.date_created_time,
        feature_name: item?.feature_id?.name,
        credit_used: item?.credit_used,
      };
    });
    return modifiedTransactionData;
  };

  const getCreditData = (data) => {
    const modifiedCreditData = data?.map((item) => {
      return {
        id: 4,
        received_date: moment(item?.date_created).format("DD/mm/yyyy"),
        received_from: item?.transfer_from,
        credit_name: item?.name,
        total_credits: item?.no_of_credits,
      };
    });
    return modifiedCreditData;
  };

  useEffect(() => {
    if (data) {
      if (selectedOptionData?.value === "Medicine Name") {
        const medicineTable = getMedicineTable(data?.data);
        setTableData(medicineTable);
        return;
      }
      if (selectedOptionData?.value === "Transactions") {
        const transactionData = getTransactionData(data?.data);
        setTableData(transactionData);
        return;
      }
      if (selectedOptionData?.value === "Credit") {
        const creditData = getCreditData(data?.data);
        setTableData(creditData);
        return;
      }

      if (selectedOptionData?.value === "Notification Logs") {
        const logsData = getLogsData(data?.data);
        setTableData(logsData);
        return;
      }

      if (selectedOptionData?.value === "Medicine Stock") {
        const medicineStock = getMedicineStock(data?.data);
        setTableData(medicineStock);
        return;
      }

      if (selectedOptionData?.value === "Batch") {
        const batchData = getBatchData(data?.data);
        setTableData(batchData);
        return;
      }
      if (selectedOptionData?.value === "Mode of Payment") {
        const paymentModes = getPaymentModeData(data?.data);
        setTableData(paymentModes);
        return;
      }

      if (selectedOptionData?.value === "Lab Tests") {
        const labTestModes = getLabTestData(data?.data);
        setTableData(labTestModes);
        return;
      }

      if (selectedOptionData?.value === "TAG Group") {
        const tagGroupTable = data?.data?.map((tag) => {
          return {
            id: tag?.id,
            group_name: tag?.group_name,
            group_for: tag?.group_for?.name,
          };
        });
        setTableData(tagGroupTable);
        return;
      }
      const tableCols = [...selectedOptionData?.tableCols, { label: "id" }];
      const tableData = [];
      for (let i of data?.data) {
        let obj = {};
        for (let j of tableCols) {
          const exactLabel = j?.label?.replace(/ /g, "_").toLowerCase();
          if (exactLabel === "services") {
            const nameOfServices = i[exactLabel]?.map(
              (service) => service?.name_of_service
            );
            obj[exactLabel] = nameOfServices?.join(", ");
          } else if (
            exactLabel === "billing_address" ||
            exactLabel === "communication_address"
          ) {
            const { building_name, street_address, city, pincode } =
              i[exactLabel];
            obj[exactLabel] =
              `${building_name}, ${street_address}, ${city}, ${pincode}`;
          } else if (exactLabel === "transaction_type") {
            obj[exactLabel] = i[exactLabel]?.transaction_type;
          } else if (exactLabel === "service_type") {
            obj[exactLabel] = i[exactLabel]?.name;
          } else {
            obj[exactLabel] = i[exactLabel];
          }
        }
        tableData.push(obj);
      }
      setTableData(tableData);
    }
  }, [data]);

  const handleOptionClick = (idx) => {
    navigate(`/new/setup?group_id=${groupId}&option_id=${idx}`);
    setSelectedOptionData(DR_SETUP_GROUPS[groupId]?.options[idx]);
    setSearchInput("");
  };

  const handleView = (id, mode) => {
    if (selectedOptionData?.value === "Customer Master") {
      navigate(
        `/new/setup/customersetup?active=customerdetails&group_id=${groupId}&option_id=${optionId}&mode=${mode}&id=${id}`
      );
    } else {
      navigate(
        `/new/setup?group_id=${groupId}&option_id=${optionId}&mode=${mode}&id=${id}`
      );
    }
  };

  const handleCreateClick = () => {
    if (selectedOptionData?.value === "Customer Master") {
      navigate(
        `/new/setup/customersetup?active=customerdetails&mode=create&group_id=${groupId}&option_id=${optionId}`
      );
      return;
    }
    navigate(
      `/new/setup?group_id=${groupId}&option_id=${optionId}&mode=create`
    );
  };

  const handleGoToPage = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    } else {
      toast.error("Page not found");
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleGoToPage(parseInt(event.target.value));
    }
  };

  const updateClinicMutation = useSecureUpdateItem(
    ApiEndPoint.CLINIC,
    ApiEndPoint.QP_CM_MEDICINE_DATA
  );
  const deleteMutation = useSecureDeleteItem(selectedOptionData?.offset);

  const handleUnlinkMedicine = (delId) => {
    const payload = {
      action: "patchUnlinkedMedicineList",
      clinic_id: clinic?.id,
      backend: "True",
      doctor_details_id: role_id,
      unlinked_medicine: [Number(delId)],
    };

    updateClinicMutation.mutate(
      { id: null, data: payload },
      {
        onSuccess: () => {
          toast.success("deleted successfully");
          setDeleteId(null);
        },
        onError: (err) => toast.error(err.response.data.message),
      }
    );
  };

  const handleDeleteData = (delId) => {
    if (selectedOptionData?.value === "Medicine Name") {
      handleUnlinkMedicine(delId);
      return;
    }
    const payload = {
      action: selectedOptionData?.deleteAction,
      clinic_id: clinic?.id,
      backend: "True",
      id: Number(delId),
    };

    deleteMutation.mutate(payload, {
      onSuccess: () => {
        toast.success("Deleted Successfully");
        setDeleteId(null);
      },
      onError: (err) => toast.error(err.response.data.message),
    });
  };

  const { data: creditUsedData, isLoading: creditUsedDataLoading } =
    useItemsFilter(
      ApiEndPoint.SUBSCRIPTIONS,
      `?action=getCredit&clinic_id=${clinic?.id}&&backend=True`,
      clinic && selectedOptionData?.value === "Credit" ? true : false
    );

  // //("creditUsedData------------", creditUsedData);
  const creditUsedDatas = creditUsedData?.length > 0 && creditUsedData[0];

  useEffect(() => {
    setCurrentPage(1);
  }, [optionId]);

  return (
    <>
      {DR_SETUP_GROUPS[groupId]?.options.length > 0 ? (
        <div className="cu-setup-options-main gap-[25px] large:gap-[35px]">
          <div className="cu-setup-options-menu">
            {DR_SETUP_GROUPS[groupId]?.options?.map((option, idx) => {
              return (
                <div
                  key={option?.id}
                  className={`cu-setup-option ${
                    selectedOptionData?.value === option?.value
                      ? "cu-setup-option-active"
                      : ""
                  }`}
                  onClick={() => handleOptionClick(idx)}
                >
                  {option?.value}
                </div>
              );
            })}
          </div>
          {selectedOptionData.value === "Credit" && (
            <div className="flex items-center gap-4 mb-5 flex-wrap">
              <div className="w-[400px] h-[200px] border rounded flex justify-center text-center flex-col gap-10">
                <div className="text-sm text-[#6D6D6D]">
                  Total Credits Remaining
                </div>
                <div className="text-[48px] text-[#000000]">
                  {creditUsedDataLoading ? (
                    <CuSpinner />
                  ) : (
                    <>
                      {Number(creditUsedDatas?.total_credit) -
                        Number(creditUsedDatas?.used_credit)}
                    </>
                  )}
                </div>
              </div>
              <div className="w-[400px] h-[200px] border rounded flex justify-center text-center flex-col gap-10">
                <div className="text-sm text-[#6D6D6D]">Total Credits Used</div>
                <div className="text-[48px] text-[#000000]">
                  {creditUsedDataLoading ? (
                    <CuSpinner />
                  ) : (
                    <>{creditUsedDatas?.used_credit}</>
                  )}
                </div>
              </div>
            </div>
          )}

          {!mode &&
            selectedOptionData?.value !== "Notification" &&
            selectedOptionData.value !== "TV View" &&
            selectedOptionData.value !== "Availability" &&
            selectedOptionData.value !== "Blockslot" &&
            selectedOptionData.value !== "Disclaimer" &&
            selectedOptionData.value !== "Calender Timing" &&
            selectedOptionData?.value !== "Certificate Setup" &&
            selectedOptionData?.value !== "Prescription Setup" &&
            selectedOptionData?.value !== "Questionnaire" &&
            selectedOptionData?.value !== "Certificate" &&
            selectedOptionData?.value !== "Roles and Permission" &&
            selectedOptionData?.value !== "Custom Field Setup" &&
            selectedOptionData?.value !== "Users" &&
            selectedOptionData?.value !== "Header & Footer Setup" && (
              <div className="cu-setup-table-container">
                <div className="cu-setup-table-search">
                  {selectedOptionData?.value !== "Notification Logs" &&
                    selectedOptionData.value !== "Transactions" &&
                    selectedOptionData.value !== "Credit" && (
                      <div
                        className="cu-setup-table-create-icon"
                        onClick={handleCreateClick}
                      >
                        <span>
                          <img src={ADD_ICON} alt="add icon" />
                        </span>
                        <span>{`${
                          selectedOptionData?.value === "Medicine Stock"
                            ? "Receive Inventory"
                            : "Create"
                        }`}</span>
                        <span>
                          ({isLoading ? <CuSpinner /> : data?.total_count})
                        </span>
                      </div>
                    )}
                  <div className="cu-setup-table-search-input">
                    <InputField
                      type="text"
                      placeholder="Search by Name"
                      value={searchInput}
                      search={true}
                      onChange={(e) => handleSearch(e)}
                      loading={isLoading}
                    />
                  </div>
                </div>
                <div className="cu-setup-table">
                  <table>
                    <thead className="cu-setup-table-header">
                      <tr>
                        {selectedOptionData?.tableCols?.map((col) => (
                          <th key={col?.id}>{col?.label}</th>
                        ))}
                        {selectedOptionData.value === "Notification Logs" && (
                          <>
                            <th></th>
                            <th></th>
                            <th></th>
                          </>
                        )}
                        {selectedOptionData.value !== "Transactions" &&
                          selectedOptionData.value !== "Credit" && (
                            <th>Action</th>
                          )}
                      </tr>
                    </thead>
                    <tbody>
                      {tableData?.map((trow, i) => {
                        return (
                          <tr key={i}>
                            {Object.keys(trow)?.map((key, idx) => {
                              if (key !== "id") {
                                let content = trow[key];
                                if (content?.length > 30) {
                                  content = content.substring(0, 20) + "..."; // Truncate content
                                }
                                return <td key={idx}>{content}</td>;
                              }
                              return null;
                            })}
                            {selectedOptionData.value !== "Transactions" &&
                              selectedOptionData.value !== "Credit" && (
                                <td>
                                  <div className="cu-setup-table-action-col">
                                    {selectedOptionData?.value ===
                                    "Notification Logs" ? (
                                      <IoEyeSharp
                                        size={18}
                                        className="cursor-pointer"
                                        onClick={() => (
                                          setLogModalData(trow),
                                          setOpenViewMessage(true)
                                        )}
                                      />
                                    ) : (
                                      <>
                                        <RiEdit2Fill
                                          size={18}
                                          className="cursor-pointer"
                                          onClick={() =>
                                            handleView(trow?.id, "edit")
                                          }
                                        />
                                        <IoEyeSharp
                                          size={18}
                                          className="cursor-pointer"
                                          onClick={() =>
                                            handleView(trow?.id, "view")
                                          }
                                        />
                                        {selectedOptionData?.isDelete && (
                                          <FaTrash
                                            size={16}
                                            className="cursor-pointer"
                                            onClick={
                                              () => setDeleteId(trow?.id)
                                              // handleDeleteData(trow?.id)
                                            }
                                          />
                                        )}
                                      </>
                                    )}
                                  </div>
                                </td>
                              )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          {selectedOptionData.value === "TV View" && <TvView />}
          {selectedOptionData.value === "Availability" && <AvailableForm />}
          {selectedOptionData.value === "Blockslot" && <BlockSlot />}
          {selectedOptionData.value === "Disclaimer" && <Disclaimer />}
          {selectedOptionData?.value === "Calender Timing" && <CalenderSetup />}
          {selectedOptionData?.value === "Certificate Setup" && <Certificate />}
          {selectedOptionData?.value === "Prescription Setup" && (
            <PrescriptionSetup />
          )}
          {/* {selectedOptionData?.value === "Questionnaire" && <Questionnaire />} */}
          {selectedOptionData?.value === "Certificate" && <Certificate />}
          {selectedOptionData?.value === "Notification" && (
            <NotificationSetup />
          )}
          {selectedOptionData?.value === "Custom Field Setup" && (
            <CustomFields />
          )}
          {selectedOptionData?.value === "Roles and Permission" && <Roles />}
          {selectedOptionData?.value === "Users" && <UserTable />}
          {selectedOptionData?.value === "Header & Footer Setup" && (
            <HeaderSetup />
          )}

          {mode && <SetupForm selectedOption={selectedOptionData} />}
          {!mode &&
            selectedOptionData.value !== "TV View" &&
            selectedOptionData.value !== "Availability" &&
            selectedOptionData.value !== "Blockslot" &&
            selectedOptionData.value !== "Disclaimer" &&
            selectedOptionData.value !== "Calender Timing" &&
            selectedOptionData?.value !== "Certificate" &&
            selectedOptionData?.value !== "Prescription Setup" &&
            selectedOptionData?.value !== "Custom Field Setup" &&
            selectedOptionData?.value !== "Role and Permission" &&
            selectedOptionData?.value !== "Header & Footer Setup" &&
            selectedOptionData?.value !== "Questionnaire" &&
            selectedOptionData?.value !== "Notification" && (
              <PaginationComponent
                totalPages={totalPages}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                handleKeyPress={handleKeyPress}
                handleGoToPage={handleGoToPage}
                perPageLimit={perPageLimit}
                setPerPageLimit={setPerPageLimit}
              />
            )}

          {openViewMessage && (
            <Modal
              isOpen={openViewMessage}
              onClose={() => setOpenViewMessage(false)}
            >
              <Modal.Header>
                <div className="py-2 flex justify-between items-center">
                  <div className="text-lg font-semibold">Show Message</div>
                  <button
                    onClick={() => setOpenViewMessage(false)}
                    className="text-gray-600 hover:text-gray-900 text-xl"
                  >
                    &times;
                  </button>
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="w-[400px] mt-1">
                  <div className="flex gap-2 items-center mt-2">
                    <div className="font-bold">Send To : </div>
                    <div className="flex gap-2 items-center">
                      <span>{logModalData?.send_to}</span>
                      <span className="flex gap-2">
                        {logModalData?.is_email && (
                          <CiMail size={20} className="text-gray-500" />
                        )}
                        {logModalData?.is_sms && (
                          <LiaSmsSolid size={20} className="text-gray-500" />
                        )}
                        {logModalData?.is_whatsapp && (
                          <FaWhatsapp size={20} className="text-gray-500" />
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="flex gap-2 my-2">
                    <div className="font-bold">Message :</div>
                    <div className="text-sm flex-1">
                      {logModalData?.message}
                    </div>
                  </div>
                  <div className="flex gap-2 my-2">
                    <div className="font-bold">Date & Time :</div>
                    <div className="text-sm flex-1">
                      {logModalData?.date_created}
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div className="w-full py-2 flex justify-end">
                  <CuButton
                    className="border border-[#00000033] py-2 px-6 rounded-md bg-gray-100"
                    onClick={() => setOpenViewMessage(false)}
                    // isLoading={uploadfileAndSubmit.isLoading}
                  >
                    Close
                  </CuButton>
                </div>
              </Modal.Footer>
            </Modal>
          )}

          {isLoading && searchInput?.length === 0 && <CuScreenLoader />}
        </div>
      ) : (
        <EmptyState />
      )}
      {deleteId && (
        <CuModal closeModal={() => setDeleteId(null)}>
          <Confirmation
            heading={`Delete`}
            onCancel={() => setDeleteId(null)}
            onClick={() => handleDeleteData(deleteId)}
            loading={deleteMutation.isLoading}
          />
        </CuModal>
      )}
    </>
  );
};

export default SetupTable;
